module.exports = __webpack_public_path__ + "media/images/suppliers/abmgood-ad0162bee5b312c087f52d01f9eeace1.png";